import React from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import cs from "classnames";
import includes from "lodash/includes";

import { modalClose, modalChange } from "~/modules/modal/actions";
import Button from "~/components/common/Button";
import mapDispatch from "~/misc/mapDispatch";
import {
  createBookingAction,
  cancelBookingAction,
  deleteBookingAction,
} from "../../../modules/bookings/action";
import { deletBookingList } from "../../../modules/myLoads/actions";

import css from "./style.css";

const checklistArry = [
  {
    id: "notauth",
    checked: true,
    content: "I’m not authorised to book loads",
  },
  {
    id: "other",
    checked: false,
    content: "Low rate/ too far/ too heavy",
  },
  {
    id: "notknow",
    checked: false,
    content: "I don’t understand how it works",
  },
];

const popupContentMap = {
  cancel: {
    title: "Why Do You Want to Cancel Booking?",
    content: null,
  },
  notauth: {
    title: "Working With a Dispatcher?",
    content:
      "Copy the link of this load, and share it to your dispatcher. So they can do all the work for you.",
    rejectReason: "Not authorized",
  },
  other: {
    title: "We are here to help!",
    content:
      "We have prepared a how to list for you to guide you through your booking process, click Help to have go.",
    rejectReason: "Low rate",
  },
  notknow: {
    title: "Leave a message to broker?",
    content: null,
    rejectReason: "Don’t know how",
  },
  verification: {
    title: "Profile Verification",
    content:
      "Truckloads requires carrier to verify all the information below to ensure the booking process can actually happen.",
  },
  booknow: {
    title: "Book Now",
    content: "You are about to send an offer {price} to Logistic Dynamics.",
  },
  booksent: {
    title: "Booking Request Sent!",
    content: "we will notify you in the app when the broker responds.",
  },
  bookunsucc: {
    title: "Booking Request Unsuccessful",
    content: "Load has been taken, please try another one.",
  },
  delete: {
    // title: "Booking Request Unsuccessful",
    content: "Are you sure you want to delete this booking record?",
  },
};

class BookingModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checklist: checklistArry,
      popupContentMap: popupContentMap,
      showtype: this.props.bookType || "booknow",
      loadId: this.props,
      showTips: false,
    };
    this.btnDisable = false;
    const { userInfo } = this.props.account;
    this.verifyLinkStr = "/free-account";
    if (this.props.account.accountLevel > this.props.account.free) {
      if (
        userInfo.data.userRole &&
        includes(userInfo.data.userRole.toLocaleLowerCase(), "admin")
      )
        this.verifyLinkStr = "/my-account";
      if (
        userInfo.data.userRole &&
        includes(userInfo.data.userRole.toLocaleLowerCase(), "user")
      )
        this.verifyLinkStr = "/user-account";
    }
    console.log(this.verifyLinkStr);
  }
  componentDidMount() {
    if (this.props.context.needVerification) {
      this.setState({ showtype: "verification" });
    }
    // this.setState({ checklist: checklistArry });
  }
  updateChecklist(e, id) {
    e.stopPropagation();
    e.preventDefault();
    const temp = this.state.checklist.map((item) => {
      item.checked = false;
      if (item.id === id) item.checked = true;
      return item;
    });
    Array.isArray(temp) &&
      temp.length !== 0 &&
      this.setState({ checklist: temp });
  }
  nextFun() {
    const selectedItem = this.state.checklist.find((item) => item.checked);
    this.setState({ showtype: selectedItem.id });
  }
  createBooking() {
    if (this.btnDisable) return;
    this.btnDisable = true;
    const postData = {
      loadId: this.props.context.loadId,
      deadhead: "0",
    };
    this.props.createBooking(postData).then((res) => {
      this.btnDisable = false;
      if (!res.errors) this.setState({ showtype: "booksent" });
      else this.setState({ showtype: "bookunsucc" });
    });
  }
  cancelBooking(type) {
    if (this.btnDisable) return;
    this.btnDisable = true;
    const { bookingId } = this.props.context.bookData;

    let rejectReason =
      this.state.popupContentMap[this.state.showtype].rejectReason;
    if (
      this.state.showtype === "notknow" &&
      type !== "anyway" &&
      this.state.textareaVal
    ) {
      rejectReason = this.textarea.value;
    }
    this.props
      .cancelBooking({
        bookingId,
        rejectReason,
        loadId: this.props.context.loadId,
      })
      .then((res) => {
        this.btnDisable = false;
        this.props.context.updateButton && this.props.context.updateButton();
        this.props.closePop();
      });
  }
  deleteBooking() {
    if (this.btnDisable) return;
    this.btnDisable = true;
    const { bookingId } = this.props.context.bookData;
    this.props
      .deleteBooking({ bookingId, loadId: this.props.context.loadId })
      .then((res) => {
        this.btnDisable = false;
        this.props.deletBookingLoads(this.props.context.loadId);
      });
  }
  render() {
    const { popupContentMap, showtype, textareaValue } = this.state;
    const context = this.props.context;
    const url = `${window.location.origin}/loads/${context.loadId}/from-${
      context.from.city || context.from.state || "Anywhere"
    }-to-${context.to.city || context.to.state || "Anywhere"}`;

    const DeleteContent = () => {
      return (
        <div>
          <main className={css.bookingMainNormal}>
            {popupContentMap["delete"].content}
          </main>
          <footer className={css.bookingFooter}>
            <div
              className={cs(css.bookingFooterRow, css.bookingFooterRowCenter)}
            >
              <Button
                onClick={this.props.closePop}
                mods={["large"]}
                className={css.bookingFooterBtn}
              >
                No
              </Button>
              <Button
                mods={["large", "action"]}
                className={css.bookingFooterBtn}
                onClick={() => {
                  this.props.closePop();
                  this.deleteBooking.call(this);
                }}
                disabled={this.btnDisable}
              >
                Yes
              </Button>
            </div>
          </footer>
        </div>
      );
    };

    const BookunsuccContent = () => {
      return (
        <div>
          <header className={css.bookingTitle}>
            <img src="/assets/ic-unsucc.png" className={css.bookingTitleIcon} />
            <p>{popupContentMap["bookunsucc"].title}</p>
          </header>
          <main className={css.bookingMainNormal}>
            {popupContentMap["bookunsucc"].content}
          </main>
          <footer className={css.bookingFooter}>
            <div
              className={cs(css.bookingFooterRow, css.bookingFooterRowCenter)}
            >
              <Button
                mods={["large", "action"]}
                className={css.bookingFooterBtn}
                onClick={this.props.closePop}
                // disabled={!offer}
              >
                OK，Got It
              </Button>
            </div>
          </footer>
        </div>
      );
    };

    const BooksentContent = () => {
      return (
        <div>
          <header className={css.bookingTitle}>
            <img src="/assets/ic-succ.png" className={css.bookingTitleIcon} />
            <p>{popupContentMap["booksent"].title}</p>
          </header>
          <main className={css.bookingMainNormal}>
            {popupContentMap["booksent"].content}
          </main>
          <footer className={css.bookingFooter}>
            <div
              className={cs(css.bookingFooterRow, css.bookingFooterRowCenter)}
            >
              <Button
                mods={["large", "action"]}
                className={css.bookingFooterBtn}
                onClick={() => {
                  this.props.closePop();
                  window.open(url);
                }}
              >
                Loads Details
              </Button>
            </div>
          </footer>
        </div>
      );
    };

    const BooknowContent = () => {
      const showContent = popupContentMap["booknow"].content.replace(
        "{price}",
        this.props.context.price
      );
      return (
        <div>
          <header className={css.bookingTitle}>
            <p>{popupContentMap["booknow"].title}</p>
          </header>
          <main className={css.bookingMainNormal}>{showContent}</main>
          <footer className={css.bookingFooter}>
            <div className={css.bookingFooterRow}>
              <Button
                onClick={this.props.closePop}
                mods={["large"]}
                className={css.bookingFooterBtn}
              >
                Not Now
              </Button>
              <Button
                mods={["large", "action"]}
                className={css.bookingFooterBtn}
                onClick={() => {
                  this.createBooking.call(this);
                }}
                disabled={this.btnDisable}
              >
                Send Request
              </Button>
            </div>
          </footer>
        </div>
      );
    };

    const VerificationContent = () => {
      return (
        <div>
          <header className={css.bookingTitle}>
            <p>{popupContentMap["verification"].title}</p>
          </header>
          <main className={css.bookingMainNormal}>
            {popupContentMap["verification"].content}
          </main>
          <footer className={css.bookingFooter}>
            <div className={css.bookingFooterRow}>
              <Button
                onClick={this.props.closePop}
                mods={["large"]}
                className={css.bookingFooterBtn}
              >
                Not Now
              </Button>
              <Button
                mods={["large", "action"]}
                className={css.bookingFooterBtn}
                onClick={() => {
                  setTimeout(() => {
                    this.props.closePop();
                  }, 0);
                  this.props.linkTo(this.verifyLinkStr);
                }}
              >
                Verify
              </Button>
            </div>
          </footer>
        </div>
      );
    };

    const NotknowContent = () => {
      return (
        <div>
          <header className={css.bookingTitle}>
            <p>{popupContentMap["notknow"].title}</p>
          </header>
          <main className={css.bookingMainNormal}>
            <textarea
              className={css.bookingMainTextarea}
              ref={(ref) => {
                this.textarea = ref;
              }}
              placeholder="Enter your message here..."
            ></textarea>
          </main>
          <footer className={css.bookingFooter}>
            <div className={css.bookingFooterRow}>
              <Button
                mods={["large", "action"]}
                className={css.bookingFooterBtn}
                onClick={() => {
                  this.cancelBooking.call(this);
                }}
                disabled={this.btnDisable}
              >
                Send & Cancel
              </Button>
              <Button
                onClick={() => {
                  this.cancelBooking.call(this, "anyway");
                }}
                mods={["large"]}
                className={css.bookingFooterBtn}
                disabled={this.btnDisable}
              >
                Cancel Anyway
              </Button>
            </div>
          </footer>
        </div>
      );
    };

    const OtherContent = () => {
      return (
        <div>
          <header className={css.bookingTitle}>
            <p>{popupContentMap["other"].title}</p>
          </header>
          <main className={css.bookingMainNormal}>
            {popupContentMap["other"].content}
          </main>
          <footer className={css.bookingFooter}>
            <div className={css.bookingFooterRow}>
              <Button
                mods={["large", "action"]}
                className={css.bookingFooterBtn}
                onClick={() => {
                  window.open(
                    "http://support-wp.truckerpath.com/service/how-to-use-book-now/"
                  );
                }}
              >
                Help
              </Button>
              <Button
                onClick={() => {
                  this.cancelBooking.call(this);
                }}
                mods={["large"]}
                className={css.bookingFooterBtn}
                disabled={this.btnDisable}
              >
                Cancel Anyway
              </Button>
            </div>
          </footer>
        </div>
      );
    };

    const NotauthContent = () => {
      return (
        <div>
          <header className={css.bookingTitle}>
            <p>{popupContentMap["notauth"].title}</p>
          </header>
          <main className={css.bookingMainNormal}>
            {popupContentMap[showtype].content}
          </main>
          <footer className={css.bookingFooter}>
            <input
              type="text"
              className={css.bookingHideInput}
              value={url}
              ref={(ref) => {
                this.hideInput = ref;
              }}
            />
            <div className={css.bookingFooterRow}>
              <Button
                mods={["large", "action"]}
                className={css.bookingFooterBtn}
                onClick={() => {
                  this.hideInput.select();
                  document.execCommand("Copy");
                  this.setState({ showTips: true });
                  setTimeout(() => {
                    this.setState({ showTips: false });
                    this.props.closePop();
                  }, 1000);
                }}
              >
                Copy Link/Email
              </Button>
              <Button
                onClick={() => {
                  this.cancelBooking.call(this);
                }}
                mods={["large"]}
                className={css.bookingFooterBtn}
                disabled={this.btnDisable}
              >
                Cancel Anyway
              </Button>
            </div>
          </footer>
        </div>
      );
    };

    const CancelContent = () => {
      return (
        <div>
          <header className={css.bookingTitle}>
            <p>{popupContentMap["cancel"].title}</p>
          </header>
          <main className={css.bookingMainNormal}>
            <div className={css.bookingChecklist}>
              {this.state.checklist.map((item) => (
                <div
                  className={css.bookingChecklistItem}
                  key={item.content}
                  onClick={(e) => this.updateChecklist(e, item.id)}
                >
                  {item.checked ? (
                    <div
                      className={cs(
                        css.bookingChecklistBtn,
                        css.bookingChecklistBtnSelected
                      )}
                    ></div>
                  ) : (
                    <div className={css.bookingChecklistBtn}></div>
                  )}
                  <label className={css.bookingChecklistLabel}>
                    {item.content}
                  </label>
                </div>
              ))}
            </div>
          </main>
          <footer className={css.bookingFooter}>
            <div className={css.bookingFooterRow}>
              <Button
                onClick={this.props.closePop}
                mods={["large"]}
                className={css.bookingFooterBtn}
              >
                Cancel
              </Button>
              <Button
                mods={["large", "action"]}
                className={css.bookingFooterBtn}
                onClick={() => this.nextFun()}
              >
                Next
              </Button>
            </div>
          </footer>
        </div>
      );
    };

    const ShowContent = (props) => {
      switch (props.type) {
        case "cancel":
          return <CancelContent />;
        case "notauth":
          return <NotauthContent />;
        case "other":
          return <OtherContent />;
        case "notknow":
          return <NotknowContent />;
        case "verification":
          return <VerificationContent />;
        case "booknow":
          return <BooknowContent />;
        case "booksent":
          return <BooksentContent />;
        case "bookunsucc":
          return <BookunsuccContent />;
        case "delete":
          return <DeleteContent />;
        default:
          return <CancelContent />;
      }
    };

    const BlackTips = (props) => {
      return (
        <section className={css.blackTips}>
          <span>{props.text}</span>
        </section>
      );
    };

    return (
      <section className={css.bookingModal}>
        <ShowContent type={showtype} />
        {this.state.showTips && <BlackTips text={"Copy Success"} />}
      </section>
    );
  }
}

export default connect(
  (state, ownProps) => ({
    account: state.account,
    ...ownProps,
  }),
  mapDispatch({
    closePop: (props) => modalClose(props.bookType),
    linkTo: (props, url) => push(url),
    createBooking: (props, createData) => createBookingAction(createData),
    cancelBooking: (props, { bookingId, rejectReason, loadId }) =>
      cancelBookingAction({ bookingId, rejectReason, loadId }),
    deleteBooking: (props, { bookingId, loadId }) =>
      deleteBookingAction({ bookingId, loadId }),
    deletBookingLoads: (props, loadId) => deletBookingList(loadId),
  })
)(BookingModal);



// WEBPACK FOOTER //
// ./src/components/Popup/Booking/index.js